import styled from 'styled-components';

export const CategoryNameStyled = styled.span`
  display: block;
`;
